import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { Icon } from '@iconify-icon/react';
import { cn } from '#lib/helpers/class.js';
import { colorValues } from './profiles.jsx';


//COMPONENTS
function PickerRadio(props) {
    return <input className="opacity-0 inset-0 absolute" {...props} type="radio" />;
}

function PickerTarget(props) {
    const { children, ...rest } = props;
    return (
        <div className="border rounded aspect-square w-10 relative isolate" {...rest}>
            {children}
        </div>
    );
}

function PickerLabel(props) {
    const { children, ...rest } = props;
    return <label {...rest}>{children}</label>;
}

function Picker(props) {
    const { children, ...rest } = props;

    return (
        <div className="flex flex-col gap-1 items-center text-center text-xs" {...rest}>
            {children}
        </div>
    );
}

// Radio input for primary and neutral styles
export function ColorRadio(props) {
    const { label, shades, value, selected, ...radioProps } = props;
    const id = `primary-${value}`;

    return (
        <Picker>
            <PickerTarget
                className="border rounded aspect-square w-10 relative isolate hover:brightness-125"
                style={{
                    backgroundColor: shades[600],
                    borderColor: shades[500]
                }}
            >
                <PickerRadio
                    className="w-full h-full left-0 cursor-pointer opacity-0"
                    value={value}
                    id={id}
                    {...radioProps}
                />
                {selected && <div className='absolute -top-2 -right-2 cursor-pointer text-white'>
                    <CheckIcon className='w-6 h-6 bg-neutral-50 rounded-[50%] text-primary-500 shadow-md shadow-neutral-500' />
                </div>}
            </PickerTarget>
            <PickerLabel htmlFor={id}>{label}</PickerLabel>
        </Picker>
    );
}

// Radio input for deselect styles
export function NoneColorRadio(props) {
    const { label, value, handleClick, ...radioProps } = props;

    return (
        <Picker>
            <PickerTarget className="border rounded aspect-square w-10 relative isolate bg-neutral-50 border-neutral-200">
                <Icon
                    icon="material-symbols:do-not-disturb-on-outline-rounded"
                    width="1.2rem"
                    height="1.2rem"
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    onClick={handleClick}
                />
                <PickerRadio
                    className="w-full h-full left-0 cursor-pointer opacity-0"
                    value={value}
                    id="none"
                    {...radioProps}
                />
            </PickerTarget>
            <PickerLabel htmlFor="none">{label}</PickerLabel>
        </Picker>
    );
}

// Radio Input to open custom palettes
export function CustomRadio(props) {
    const { label, shades, selected, value, ...radioProps } = props;
    return (
        <Picker>
            <PickerTarget className="border rounded aspect-square w-10 relative isolate bg-neutral-50 border-neutral-200">
                <Icon
                    icon="material-symbols-light:add"
                    width="1.6rem"
                    height="1.6rem"
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                />

                <PickerRadio
                    className="w-full h-full left-0 cursor-pointer opacity-0"
                    value={value}
                    id={value}
                    {...radioProps}
                />
                {selected && <div className='absolute -top-2 -right-2 cursor-pointer text-white'>
                    <CheckIcon className='w-6 h-6 bg-neutral-50 rounded-[50%] text-primary-500 shadow-md' />
                </div>}
            </PickerTarget>
            <PickerLabel htmlFor={value}>{label}</PickerLabel>
        </Picker>
    );
}

// function to render custom palette
export function CustomPickers(props) {
    const { colors, type, editProfile, preview, profileId } = props;

    const handleChange = (e, num) => {
        const {name, value} = e.target;
        colors[num] = value;
        editProfile(profileId, type, name, colors)

    };

    return (
        <div
            className={cn(
                'w-full p-2 md:p-0 flex flex-wrap justify-center md:justify-start gap-3',
                preview && 'md:px-4 md:py-3 md:justify-center gap-2'
            )}
        >
            {colorValues.map((num) => {
                return (
                    <div key={num} className="flex flex-col items-center">
                        <input
                            type="color"
                            className="w-10 h-10 cursor-pointer"
                            style={{ width: preview && 21, height: preview && 21 }}
                            value={colors[num] || '#000000'}
                            name={type}
                            onChange={(e) => handleChange(e, num)}
                        />
                        <label className="text-center text-xs">{num}</label>
                    </div>
                );
            })}
        </div>
    );
}